<!-- if user.employee.roles includes Role.Seller means user is seller -->
<!-- and if the user roles includes seller, means he can not have any other role  -->

@if (userRoles && (userRoles?.length || 0) > 0) {
  <section class="dashboard-page">
    @if (
      userRoles.includes(RolesEnum.EmergencyMode) &&
      !userRoles.includes(RolesEnum.ViewStat)
    ) {
      <div>
        <h1>
          {{
            "dashboard.welcomeMessage"
              | translate: {user: `${user?.first_name} ${user?.last_name}`}
          }}
        </h1>
      </div>
    } @else {
      <div>
        @if (form && user?.profile) {
          <form
            class="grid grid-cols-2 min-[764px]:grid-cols-4 gap-10"
            [formGroup]="form"
          >
            <!-- from date -->
            <app-date-picker
              labelKey="fromDate"
              formControlName="fromDate"
              [formGroup]="form"
            ></app-date-picker>
            <!-- to date -->
            <app-date-picker
              labelKey="toDate"
              formControlName="toDate"
              [formGroup]="form"
            ></app-date-picker>
            <!-- sellers  -->
            <app-select
              labelKey="seller"
              formControlName="seller"
              [formGroup]="form"
              [options]="sellersSelectOptions"
              [loading]="sellersSelectOptions.length === 0"
            ></app-select>
            <button
              mat-flat-button
              color="primary"
              class="w-28 !h-14 !text-white mb-5"
              (click)="submitForm()"
            >
              {{ "filter" | translate }}
            </button>
          </form>
        }

        <section class="dashboard grid grid-rows-1 gap-3">
          <div
            class="grid grid-cols-1 min-[1280px]:grid-cols-3 gap-y-4 min-[1280px]:gap-x-4 p-[3px]"
          >
            <div class="col-span-3">
              <app-sales-stat></app-sales-stat>
            </div>
            <!--<app-payment-status-stat></app-payment-status-stat>-->
          </div>

          <!-- <div class="p-[0.25rem]">
            <app-inventory-report-stat></app-inventory-report-stat>
        </div> -->

          <!-- <div class="p-[0.25rem]">
              <app-product-sales-stat></app-product-sales-stat>
              </div>
        <div class="p-[0.25rem]">
            <app-day-of-purchase-stat></app-day-of-purchase-stat>
        </div> -->
        </section>
      </div>
    }
  </section>
} @else {
  <app-dashboard-skeleton></app-dashboard-skeleton>
}
